import { render } from "./ThePageHeader.vue?vue&type=template&id=fbce7c48&scoped=true&lang=html"
import script from "./ThePageHeader.vue?vue&type=script&lang=js"
export * from "./ThePageHeader.vue?vue&type=script&lang=js"

import "./ThePageHeader.vue?vue&type=style&index=0&id=fbce7c48&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fbce7c48"

export default script